import {NgModule, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicModule, IonicErrorHandler} from 'ionic-angular';
import {MyApp} from './app.component';
import {MyInfoPage} from '../pages/my-info/my-info';
import {MyEditPage} from '../pages/my-edit/my-edit';
import {GroupPermissionsPage} from '../pages/group-permissions/group-permissions';
import {EditGroupPermsPage} from '../pages/edit-group-perms/edit-group-perms';
import {ContactAddPage} from '../pages/contact-add/contact-add';
import {ContactViewPage} from '../pages/contact-view/contact-view';
import {ContactEditPage} from '../pages/contact-edit/contact-edit';
import {ContactsPage} from '../pages/contacts/contacts';
import {ContactNewPage} from "../pages/contact-new/contact-new";
import {GroupsPage} from '../pages/groups/groups';
import {InvitePage} from '../pages/invite/invite';
import {TabsControllerPage} from '../pages/tabs-controller/tabs-controller';
import {WelcomePage} from '../pages/welcome/welcome';
import {LoginPage} from '../pages/login/login';
import {SignupPage} from '../pages/signup/signup';
import {SettingsPage} from '../pages/settings/settings';
import {GroupViewPage} from '../pages/group-view/group-view';
import {GroupAddPage} from '../pages/group-add/group-add';
import {PasswordRecoveryPage} from '../pages/password-recovery/password-recovery';
import {PasswordResetSentPage} from '../pages/password-reset-sent/password-reset-sent';


import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

@NgModule({
  declarations: [
    MyApp,
    MyInfoPage,
    MyEditPage,
    GroupPermissionsPage,
    EditGroupPermsPage,
    ContactViewPage,
    ContactEditPage,
    ContactAddPage,
    ContactNewPage,
    ContactsPage,
    GroupsPage,
    InvitePage,
    TabsControllerPage,
    WelcomePage,
    LoginPage,
    SignupPage,
    SettingsPage,
    GroupViewPage,
    GroupAddPage,
    PasswordRecoveryPage,
    PasswordResetSentPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MyInfoPage,
    MyEditPage,
    GroupPermissionsPage,
    EditGroupPermsPage,
    ContactAddPage,
    ContactNewPage,
    ContactViewPage,
    ContactEditPage,
    ContactsPage,
    GroupsPage,
    InvitePage,
    TabsControllerPage,
    WelcomePage,
    LoginPage,
    SignupPage,
    SettingsPage,
    GroupViewPage,
    GroupAddPage,
    PasswordRecoveryPage,
    PasswordResetSentPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts